import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/admin/dashboard", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0c1633] px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8" data-testid="admin-login-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-11 w-11 rounded-xl bg-[#E84B1C] flex items-center justify-center">
            <Lock className="text-white" size={20} />
          </div>
          <div>
            <h1 className="font-head text-xl font-bold text-[#12284B]">Admin Login</h1>
            <p className="text-sm text-black/50">Superhost Cloud</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#12284B] mb-1.5">Email</label>
            <input
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full h-11 rounded-xl border border-[#12284B]/20 px-4 text-[#12284B] focus:outline-none focus:border-[#E84B1C]"
              placeholder="admin@superhostcloud.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#12284B] mb-1.5">Password</label>
            <input
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full h-11 rounded-xl border border-[#12284B]/20 px-4 text-[#12284B] focus:outline-none focus:border-[#E84B1C]"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <div data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full h-11 rounded-xl bg-[#E84B1C] hover:bg-[#F0673E] text-white font-head font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-60"
          >
            {loading && <Loader2 className="animate-spin" size={18} />} Log In
          </button>
        </form>
      </div>
    </div>
  );
}
